import { Controller } from "@hotwired/stimulus"

// Implements the Invoker Commands API pattern for Stimulus
// Allows a trigger element to invoke an action on a remote target element
//
// Usage:
//   <button data-controller="invoker"
//           data-invoker-for-value="my-download"
//           data-invoker-action-value="download#start">
//     Export
//   </button>
//
//   <div id="my-download" data-controller="download">...</div>
//
export default class extends Controller {
  static values = {
    for: String,    // ID of the target element
    action: String  // Stimulus action to invoke (e.g., "download#start")
  }

  connect() {
    this.boundInvoke = this.invoke.bind(this)
    this.element.addEventListener("click", this.boundInvoke)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundInvoke)
  }

  invoke(event) {
    event.preventDefault()

    const targetElement = document.getElementById(this.forValue)
    if (!targetElement) {
      console.warn(`Invoker: target element #${this.forValue} not found`)
      return
    }

    // Parse the action to get controller and method
    const [controllerName, methodName] = this.actionValue.split("#")

    // Get the Stimulus controller instance from the target element
    const controllerInstance = this.application.getControllerForElementAndIdentifier(
      targetElement,
      controllerName
    )

    if (controllerInstance && typeof controllerInstance[methodName] === "function") {
      controllerInstance[methodName](event)
    } else {
      console.warn(`Invoker: could not find ${this.actionValue} on #${this.forValue}`)
    }
  }
}
